export const theme = {
  typography: {
    fontFamily: "Montserrat",
    fontSize: 10,
    h1: {
      fontWeight: "500",
      color: "#333333",
    },
    h2: {
      fontWeight: "500",
      color: "#333333",
    },
    h3: {
      fontWeight: "500",
      color: "#333333",
    },
    h4: {
      fontWeight: "500",
      color: "#333333",
    },
    h5: {
      fontWeight: "500",
      color: "#333333",
    },
    h6: {
      fontWeight: "500",
      color: "#333333",
    },
    subtitle1: {
      fontWeight: "500",
      color: "#333333",
    },
    button:{
      fontWeight: "500",
    }
  },
  palette: {
    primary: {
      main: "#D3B925",
      main2: "#009975",
    },
  },
};
